(function () {'use strict';}());

angular.module('app')
  .controller('AssessmentController', function ($scope,$timeout,$filter,$window,AppService) {
  	var trace = angular.trace;
    var autoAssigned = false;
    $scope.ASSESSMENT_SCREEN_LANDING    = 0;
    $scope.ASSESSMENT_SCREEN_QUESTIONS  = 1;
    $scope.ASSESSMENT_SCREEN_FEEDBACK_LANDING  = 2;
    $scope.ASSESSMENT_SCREEN_FEEDBACK  = 3;
    $scope.ASSESSMENT_SCREEN_CHART  = 4;
    $scope.ASSESSMENT_FEEDBACK_RISK = "risk";
    $scope.ASSESSMENT_FEEDBACK_PROTECTIVE = "protective";
    $scope.ASSESSMENT_FEEDBACK_USE = "use";
    
    $scope.SCALE_NUMERIC = [{label: "Select an Option", value: -1}, {label: "0", value: 0}, {label: "1", value: 1}, {label: "2", value: 2}, {label: "3", value: 3}, {label: "4", value: 4}, {label: "5", value: 5}, {label: "6", value: 6}, {label: "7", value: 7}];
    $scope.SCALE_NUMERIC_ALT = [{label: "Select an Option", value: -1}, {label: "0", value: 0}, {label: "1", value: 1}, {label: "2", value: 2}, {label: "3", value: 3}, {label: "4", value: 4}, {label: "5", value: 5}, {label: "6", value: 6}, {label: "7", value: 7}, {label: "N/A", value: "N/A"}];
    $scope.SCALE_LIKERT = [{label: "Select an Option", value: -1}, {label: "Not at all", value: 0}, {label: "Slightly", value: 1}, {label: "Moderately", value: 2}, {label: "Considerably", value: 3}, {label: "Extremely", value: 4}];

    $scope.currentQuestionIndex = 0;
    $scope.currentFeedbackType = null;
    $scope.currentFeedbackQuestions = null;
    $scope.currentUseScreenIndex = 0;
    $scope.highs = [];
    $scope.moderates = [];
    $scope.lows = [];
    $scope.iquestions = [];

    $scope.$watch("questions",onQuestionsSet);
    
    $scope.$on("assessmentChange",function(){
      $scope.setFeedbackType($scope.currentFeedbackType);
    });

    $scope.blockAssessment = function(){
      alert("Your first assessment is not yet available. Check back on Sunday.");
    };

    $scope.setCurrentScreen = function(value) {
      $scope.containerClasses.saving = true;
      $timeout(function() {
        $scope.currentAssessmentScreen = value;

        if(value === $scope.ASSESSMENT_SCREEN_FEEDBACK_LANDING) $scope.customClasses["assessment-feedback"] = true;
        else delete $scope.customClasses["assessment-feedback"];

        if(value === $scope.ASSESSMENT_SCREEN_FEEDBACK) $scope.customClasses["assessment-feedback-detail"] = true;
        else delete $scope.customClasses["assessment-feedback-detail"];

        $timeout(fadein,0);
      }, $scope.TRANSITION_SPEED);
    };

    function fadein() {
      $scope.containerClasses.saving = false;
    }

    $scope.saveQuestion = function(question){
      $scope.iquestions = $filter('conditionalquestions')($scope.questions);
      var lastQuestion = $scope.iquestions.indexOf(question) === $scope.iquestions.length - 1;
      $scope.containerClasses.saving = true;
      $scope.containerClasses.showLoader = true;
      $timeout(function() {
        AppService.saveUserResponseForAssessment(question, lastQuestion).then(onQuestionSaveComplete);
      }, $scope.TRANSITION_SPEED);
      
    };

    $scope.skip = function() {
      $scope.containerClasses.saving = true;
      $scope.containerClasses.showLoader = true;
      $timeout(function() {
        onQuestionSaveComplete();
      }, $scope.TRANSITION_SPEED);
    };

    $scope.getWeekForId = function(id){
      return AppService.getWeekForId(id);
    };

    $scope.getTip = function(item) {
      var tips = item.feedback.tips;
      var matches = tips.match(/<li.*?\/li>/gim);
      if(!matches.length) return "";

      var match = matches[Math.floor(Math.random() * matches.length)];
      if(!match) return "";
      return match.replace(/<\/?li>/gim,"");
    };

    function onQuestionSaveComplete(result){
      if(result && !result.data.authenticated) return $window.location.reload();
      

      if($scope.currentQuestionIndex < $scope.iquestions.length - 1) {
        $scope.currentQuestionIndex ++;
        $scope.currentQuestion = $scope.iquestions[$scope.currentQuestionIndex];
        $timeout(function(){
          $scope.containerClasses.saving = false;
          $scope.containerClasses.showLoader = false;
        },0);
      } else {
        $scope.containerClasses.saving = true;
        AppService.loadAppContent().then(function(value){
          scoreAssessment();
          $scope.currentAssessmentScreen = $scope.ASSESSMENT_SCREEN_FEEDBACK_LANDING;
          $scope.customClasses["assessment-feedback"] = true;
          $timeout(function(){
            $scope.containerClasses.saving = false;
            $scope.containerClasses.showLoader = false;
          },0);
        });
        
      }
    }

    var configured = false;

    function onQuestionsSet(value){
      if(!value || configured === true) return;
      var answered = $filter('response')(AppService.assessmentResults,AppService.currentAssessmentID);
      $scope.mostCurrentAssessment =  AppService.currentAssessmentID;
      $scope.mostCurrentAssessmentWeek = AppService.currentAssessmentWeek;
      $scope.currentQuestion = $scope.questions[0];
      $scope.questions.forEach(function(q){
        if(q.configured === true) return;
        q.userResponse = getResponseOption(q.userResponse, $scope.getScale(q.scale), q);
        q.configured = true;
      });
      $scope.iquestions = $filter('conditionalquestions')($scope.questions);

      if(answered.length === $scope.iquestions.length) {
        scoreAssessment();
        $scope.setCurrentScreen($scope.ASSESSMENT_SCREEN_FEEDBACK_LANDING);
      } else {
        $scope.setCurrentScreen($scope.ASSESSMENT_SCREEN_LANDING);
      }

      configured = true;
    }

    $scope.getScale = function(type) {
      if(type === "likert") return $scope.SCALE_LIKERT;
      if(type === "week-na") return  $scope.SCALE_NUMERIC_ALT;
      return  $scope.SCALE_NUMERIC;
    };

    function getResponseOption(value, array, question) {
      for(var i = 0, count = array.length; i < count; i++) {
        var item = array[i];
        if(item.value === parseInt(value)) return item;
        if(item.value === "N/A" && value === "N/A") return item;
      }

      return array[0];
    }

    function filterByAbbreviation(e) {
      return e.abbreviated === this.abbreviated;
    }

    function sortByRisk(a,b) {
      var values = {"low": 1, "moderate": 2, "high": 3};
      var valueA = values[a.label] || 0;
      var valueB = values[b.label] || 0;

      if(valueA > valueB) return 1;
      if(valueA < valueB) return -1;
      return 0;
    }

    function scoreAssessment() {
      var scored = $scope.iquestions.map(adjustScores);
      var found = [];
      var groups = $scope.iquestions.filter(function(e){
        if(found.indexOf(e.abbreviated) !== -1) return false;
        if(e.userResponse && e.userResponse.value === "N/A") return false;
        found.push(e.abbreviated);
        return true;
      });

      groups = groups.map(function(e) {
        var group = {name: e.abbreviated};
        group.items = scored.filter(filterByAbbreviation, {abbreviated: e.abbreviated});
        group.items.sort(sortByRisk);
        return group;
      });


      scored.forEach(getFeedbackForQuestion);

      $scope.groups = groups;

      /*
      $scope.highs = scored.filter(filterByRange, {type: "high"});
      $scope.moderates = scored.filter(filterByRange, {type: "moderate"});
      $scope.lows = scored.filter(filterByRange, {type: "low"});*/
    }

    function adjustScores(question) {
      var response = question.userResponse.value;
      var scale = question.scale;
      var type = question.type;

      if(response === -1) return {label:"skipped",value:0, abbreviated: null};

      if(scale.match("week") && type === "risk" &&  response < 1) return {label:"low",value:0, question: question, abbreviated: question.abbreviated};
      if(scale.match("week") && type === "risk" &&  response == 1) return {label:"moderate",value:1, question: question, abbreviated: question.abbreviated};
      if(scale.match("week") && type === "risk" &&  response > 1) return {label:"high",value:2, question: question, abbreviated: question.abbreviated};

      if(scale.match("week") && type === "protective" &&  response <= 1) return {label:"high",value:0, question: question, abbreviated: question.abbreviated};
      if(scale.match("week") && type === "protective" &&  response <= 4) return {label:"moderate",value:1, question: question, abbreviated: question.abbreviated};
      if(scale.match("week") && type === "protective" &&  response > 4) return {label:"low",value:2, question: question, abbreviated: question.abbreviated};

      if(scale.match("week") && type === "use" &&  response === 0) return {label:"low",value:0, question: question, abbreviated: question.abbreviated};
      if(scale.match("week") && type === "use" &&  response === 1) return {label:"moderate",value:1, question: question, abbreviated: question.abbreviated};
      if(scale.match("week") && type === "use" &&  response > 1) return {label:"high",value:2, question: question, abbreviated: question.abbreviated};

      if(scale === "likert" && type === "risk" && response === 0) return {label:"low",value:0, question: question, abbreviated: question.abbreviated};
      if(scale === "likert" && type === "risk" && response === 1) return {label:"moderate",value:1, question: question, abbreviated: question.abbreviated};
      if(scale === "likert" && type === "risk" && response > 1) return {label:"high",value:2, question: question, abbreviated: question.abbreviated};

      if(scale === "likert" && type === "protective" && response <= 2) return {label:"high",value:0, question: question, abbreviated: question.abbreviated};
      if(scale === "likert" && type === "protective" && response === 3) return {label:"moderate",value:1, question: question, abbreviated: question.abbreviated};
      if(scale === "likert" && type === "protective" && response > 3) return {label:"low",value:2, question: question, abbreviated: question.abbreviated};
      return {label:"n/a",value:0, abbreviated: question.abbreviated};
    }

    function getFeedbackForQuestion(info) {
      if(!info || !info.question) return "Skipped";

      var id = info.question.id;
      var score = info.label;
      var options = AppService.feedback;
      info.meaningExpanded = false;
      info.recommendationExpanded = false;

      for(var i = 0, count = options.length; i < count; i++) {
        var option = options[i];
        if(option.score === score && option.questionID === id) {
          info.feedback = option;
          break;
        }
      }

      if(info.feedback.tips) info.feedback.tip = $scope.getTip(info);
    }

    function filterByRange(question) {
      var range = this.type;
      if(question.label === range) {
        if(!autoAssigned) {
          question.meaningExpanded = true;
          question.recommendationExpanded = true;
          autoAssigned = true;
        }
        return true;
      }
      return false;
    }

  });
